/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { TaskDataDouble } from '../../../../../../../models/task.model';

@Component({
  selector: 'app-double-item',
  templateUrl: './double-item.component.html',
  styleUrls: ['./double-item.component.scss'],
  standalone: false
})
export class DoubleItemComponent implements OnInit {
  @Input() doubleItem: TaskDataDouble = new TaskDataDouble(0);

  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
